$(function () {
    // Page: Custom Solutions

    if ($('#processSlider').length > 0) {
        var $processSlider = $('#processSlider').slick({
            focusOnSelect: true,
            centerMode: false,
            centerPadding: '0px',
            initialSlide: 0,
            slidesToShow: 4,
            slidesToScroll: 1,
            infinite: false,
            variableWidth: true,
            nextArrow: $('.next'),
            prevArrow: $('.previous'),
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 641,
                    settings: {
                        slidesToShow: 1
                    }
                }
            ]
        })

        $('.slick-slide[data-slick-index="0"] .row').addClass('active')
        $('.content[data-slide-content="1"]').toggleClass('active')

        $processSlider.on('click', '.slick-slide', function () {
            $('.slick-slide .row').removeClass('past').removeClass('active')

            var currentIndex = parseInt($(this).data('slick-index'))

            $('.slider-contents .content').removeClass('active')
            $('.content[data-slide-content="' + (currentIndex + 1) + '"]').addClass('active')

            for (var i = 0; i < 6; i++) {
                if (i < currentIndex) {
                    $('.slick-slide[data-slick-index="' + i + '"] .row').addClass('past')

                    continue
                }

                if (i === currentIndex) {
                    $('.slick-slide[data-slick-index="' + i + '"] .row').addClass('active')

                    continue
                }
            }
        })
    }
})
